import React from 'react';
function Communities() {

  return (
    <div className="communities">
    </div>
  );
}

export default Communities;